import React, { useState } from 'react';
import classNames from 'classnames';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { CloseCircleIcon, ArrowStatefulIcon } from '@mm/icons';
import { hideSlideoutMenu } from '@mm/state/actions/viewActions';
import { StoreState } from '@mm/state/store-interfaces';
import './SlideoutCreateEditNativeIntegration.pcss';
import mailchimpIcon from 'assets/mailchimp-icon.png';
import { Heading, Line, Status, SearchInput } from '@mm/components';
import { colors } from '@mm/utils';
import { SlideoutMenu } from '../../components/SlideoutMenu';
import { EditMailchimp } from '../../../../features/beta/modules/Integrations/NativeIntegrations/components/MailchimpIntegrations/EditMailchimp/EditMailchimp';
import { EditGoogleSheet } from '../../../../features/beta/modules/Integrations/NativeIntegrations/components/GoogleSheetsIntegrations/EditGoogleSheet/EditGoogleSheet';
import { useSlideoutOnClose } from '../SlideoutEmail/SlideoutEmail';
import { FormattedConnectionModel } from '@mm/state/model/ConnectionModel';

export type Props = {
  className?: string;
  connectionId?: number;
  isSlideout?: boolean;
  reloadConnections?: () => void;
  isMailchimp?: boolean;
  showLists?: boolean;
  connections?: FormattedConnectionModel[] | undefined;
  onListItemClick?: (connectionId: number) => void;
};

export const SlideoutCreateEditNativeIntegration = ({
  className,
  connectionId,
  isSlideout,
  reloadConnections,
  isMailchimp,
  showLists,
  connections,
  onListItemClick,
}: Props) => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const { setRef } = useSlideoutOnClose();
  const [search, onSearchChange] = useState('');
  const filteredConnections = search
    ? connections?.filter(c => c.name.toLocaleLowerCase().includes(search))
    : connections;

  return (
    <SlideoutMenu
      className={classNames(className, 'google-sheet-slideout-menu')}
      setRef={setRef}
    >
      <SlideoutMenu.Content className="google-sheet-slideout__content">
        <div className="google-sheet-slideout-header-container">
          <span
            className="google-sheet-slideout-header_close-btn"
            onClick={() => {
              dispatch(hideSlideoutMenu());
              if (reloadConnections) {
                reloadConnections();
              }
            }}
          >
            <CloseCircleIcon className="widget-adder-slideout-menu__close-icon" />
          </span>
        </div>
        {!isMailchimp && (
          <EditGoogleSheet
            connectionId={connectionId}
            isSlideout={isSlideout}
            reloadConnections={reloadConnections}
          />
        )}
        {isMailchimp && showLists && filteredConnections && onListItemClick && (
          <div className="google-sheet-slideout__mailchimp-list-container">
            <div className="google-sheet-slideout__mailchimp-lists-header">
              <img
                src={mailchimpIcon}
                className="google-sheet-slideout__mailchimp-icon"
              />
              <Heading size={2} text="Mailchimp Integrations" />
            </div>
            <Line />
            <SearchInput
              css={{
                container: 'google-sheet-slideout__mailchimp-lists-search',
              }}
              placeholder="Connection search"
              onChange={e => onSearchChange(e.target.value)}
              value={search}
            />
            {filteredConnections.map(item => (
              <div
                key={item.id}
                className="google-sheet-slideout__mailchimp-item-row"
                onClick={() => onListItemClick(item.id)}
              >
                <span className="google-sheet-slideout__mailchimp-item-name">
                  {item.name}
                </span>
                <Status
                  className="google-sheet-slideout__mailchimp-item-status"
                  status={item.statusText}
                  color={item.active ? colors.green : colors.grayLight}
                />
                <ArrowStatefulIcon
                  color="var(--color-accent-blue)"
                  direction="right"
                  onClick={() => onListItemClick(item.id)}
                />
              </div>
            ))}
          </div>
        )}
        {isMailchimp && !showLists && (
          <EditMailchimp
            connectionId={connectionId}
            isSlideout={isSlideout}
            reloadConnections={reloadConnections}
            onBackClick={() => {
              dispatch(hideSlideoutMenu());
              if (reloadConnections) {
                reloadConnections();
              }
            }}
          />
        )}
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
};
